module.exports = __webpack_public_path__ + "static/media/back-arrow.5ada210d.svg";